import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { ReviewPostEntryDetailModuleName } from '@/store/modules/modules'

export class ReviewPostEntryDetailViewModel {
  private store = useStore()

  reviewEntryDetailList: ComputedRef<{ [entryId: string]: ReviewEntryDetail[] }> = computed(
    () => this.store.getters[`${ReviewPostEntryDetailModuleName}/reviewEntryDetailList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ReviewPostEntryDetailModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${ReviewPostEntryDetailModuleName}/error`])

  async fetchReviewEntryDetailList(entryId: string): Promise<void> {
    await this.store.dispatch(`${ReviewPostEntryDetailModuleName}/fetchReviewEntryDetailList`, { entryId })
  }

  async postCloseEntry(entryId: string): Promise<void> {
    await this.store.dispatch(`${ReviewPostEntryDetailModuleName}/postCloseEntry`, { entryId })
  }

  async postEvaluationReview(reviewId: string, score: number): Promise<void> {
    await this.store.dispatch(`${ReviewPostEntryDetailModuleName}/postEvaluationReview`, { reviewId, score })
  }

  setReviewEntryDetailList(detailList: { [entryId: string]: ReviewEntryDetail[] }): void {
    this.store.commit(`${ReviewPostEntryDetailModuleName}/setReviewEntryDetailList`, { detailList })
  }

  isAlreadyDetailRequested(entryId: string): boolean {
    return entryId in this.reviewEntryDetailList.value
  }

  hasEntryDetailInList(entryId: string): boolean {
    return !this.isAlreadyDetailRequested(entryId) || this.reviewEntryDetailList.value[entryId].length > 0
  }

  getEmptyEntryDetail(): ReviewEntryDetail {
    return {
      reviewId: '',
      entryId: '',
      reviewerId: '',
      reviewDate: new Date(),
      message: '',
      prompt: '',
      revisedCode: ''
    }
  }
}
